// extracted by mini-css-extract-plugin
export default {"check-icon":"OrderReminder_check-icon__Jf7DG","reminder-button":"OrderReminder_reminder-button__Hjz1p"};